export function findProspectSelection(records, id) {
  if (id == null) return null;
  return (records || []).find(record => record?.id != null && String(record.id) === String(id)) || null;
}

export function resolveDailyQueueProspect(records, item, { storeId, consultantId, normalizePhone }) {
  const phone = normalizePhone(item?.telefone);
  if (!phone) throw new Error("Este cartão não tem um WhatsApp válido.");
  const scoped = (records || []).filter(record => record
    && Number(record.storeId) === Number(storeId)
    && Number(record.consultantId) === Number(consultantId)
    && normalizePhone(record.phone || record.telefone) === phone);
  return findProspectSelection(scoped, item.prospId) || scoped[0] || null;
}